'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = 'react-flex-v2';


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flex/lib/prefix.js
// module id = 1127
// module chunks = 0